import React from 'react';
import './FooterBar.css';

function FooterBar() {
    return (
        <footer role='contentinfo'>
            Created by Caroline Marsden
            <a href='https://github.com/carmarsden' target='_blank' rel='noopener noreferrer'>GitHub</a>
        </footer>
    );    
}

export default FooterBar;